import { render, staticRenderFns } from "./addCharter.vue?vue&type=template&id=0fe3cff0&scoped=true"
import script from "./addCharter.vue?vue&type=script&setup=true&lang=js"
export * from "./addCharter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./addCharter.vue?vue&type=style&index=0&id=0fe3cff0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe3cff0",
  null
  
)

export default component.exports